import { downloadDocFromTask } from "@/api/tasks/downloadDocFromTask"
import { useMutation } from "@tanstack/react-query"

export const useDownloadDocFromTask = () => {

  return useMutation({
    mutationKey: ['downloadDocument'],
    mutationFn: downloadDocFromTask,
    retry: 1,
    onError: (error) => {
      console.error('Error downloading document:', error);
    }
  });
}
